import {createSlice} from '@reduxjs/toolkit';
import type {RootState} from '../store';

interface NftPageState {
    isOnNftPage: boolean;
}

const initialState: NftPageState = {
    isOnNftPage: false,
};

export const nftPageSlice = createSlice({
    name: 'nftPage',
    initialState,
    reducers: {
        setOnNftPage: (state) => {
            state.isOnNftPage = true;
        },
        setOffNftPage: (state) => {
            state.isOnNftPage = false;
        }
    },
});

export const {setOnNftPage, setOffNftPage} = nftPageSlice.actions;

export const selectIsOnNftPage = (state: RootState) => state.nftPage.isOnNftPage;

export default nftPageSlice.reducer;
